import React from 'react'
import { confirmationInstructionData, detailInstructionData } from './dataWmo'
import { rmaLRPage } from '../../constant'
import {
  TimelineContainer,
  TimelineDetail,
  TimelineInstruction,
} from './style/TimelineWmo.css'

const InstructionWmo = ({ type, item }) => {
  const { itemTotal } = { ...item }
  const { header, list } = type === rmaLRPage.detail
    ? detailInstructionData
    : confirmationInstructionData

  return (
    <TimelineInstruction>
      <h4>{header}</h4>
      <TimelineContainer>
        {
          list.map(({ Detail }) => (
            <TimelineDetail key={Math.random()} >
                <Detail itemTotal={itemTotal} />
            </TimelineDetail>
          ))
        }
      </TimelineContainer>
    </TimelineInstruction>
  )
}

export default InstructionWmo
